import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "homeScreen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Sign in", -1)

import SignIn from '@/components/auth/SignIn.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SignIn)
  ]))
}
}

})